module.exports = __webpack_public_path__ + "img/wave-pattern-light.67890567.svg";